export enum FlightType {
  ONE_WAY = "oneway",
  ROUND_TRIP = "roundtrip",
  MULTI_CITY = "multicity",
  DEFAULT = "default",
}

export const FlightTypeCodeMap = {
  [FlightType.ROUND_TRIP]: "ROUND_TRIP",
  [FlightType.ONE_WAY]: "ONE_WAY",
  [FlightType.MULTI_CITY]: "MULTIPLE_DESTINATION",
  [FlightType.DEFAULT]: "ROUND_TRIP",
};
